module.exports = __webpack_public_path__ + "static/media/2-weather-app-thumb.14a5bc2a.png";